import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { issuesArchivedReducers, issuesArchivedWatchers } from './archived';
import { issuesByIdReducers, issuesByIdWatchers } from './_id';
import { issuesSnoozedReducers, issuesSnoozedWatchers } from './snoozed';
import { issuesVisibleReducers, issuesVisibleWatchers } from './visible';

export const issuesReducers = combineReducers({
	archived: issuesArchivedReducers,
	byId: issuesByIdReducers,
	snoozed: issuesSnoozedReducers,
	visible: issuesVisibleReducers
});

export const issuesWatchers = combineAllWatchers([
	issuesArchivedWatchers,
	issuesByIdWatchers,
	issuesSnoozedWatchers,
	issuesVisibleWatchers
]);
